import React, { useEffect, useState } from "react";
import SvgIcon from "./ui/SvgIcon";

const Avatar = ({ message }) => {
  const [displayedText, setDisplayedText] = useState("");
  const [isSpeaking, setIsSpeaking] = useState(false);

  useEffect(() => {
    let i = 0;
    let currentText = "";
    setDisplayedText("");     // Reset Text
    setIsSpeaking(true);      // Start Animation
    
    const interval = setInterval(() => {
      if (i < message.length) {
        currentText += message[i];
        setDisplayedText(currentText);
        i++;
      } else {
        clearInterval(interval);
        setIsSpeaking(false); // Stop Animation
      }
    }, 50);
  
    // Cleanup-Funktion bei Wechsel der Nachricht
    return () => {
      clearInterval(interval);
      setIsSpeaking(false);
    };
  }, [message]);
   // Wenn sich die Nachricht ändert, wird der Effekt erneut ausgeführt
  //{isSpeaking ? Math.floor(Math.random() * 10) : 3}
  return (
    
    <div className="avatar-container">
      <div className="svg-avatar">
        <SvgIcon/>
      </div>
      <div style={{ width: '100%', 
                  maxWidth: '250px', 
                 
                   }}>
      <div className="avatar-bubble">
        <span>{displayedText}</span>
        <div className="bubble-arrow" />
      </div>
      </div>
    </div>
   
  );
};

export default Avatar;
